import { WalletConversionErrorDto, WalletConversionErrorModel } from '../types/wallet-conversion'

export const transformWalletConversionError = ({
  title,
  body,
  button_title,
  button_url,
}: WalletConversionErrorDto): WalletConversionErrorModel => ({
  title,
  body,
  buttonTitle: button_title,
  buttonUrl: button_url,
})
